export type IPropSizes = {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'none' | null | undefined;
};

export type IPropStates = {
  state?: boolean | null | undefined;
};

export type IPropStyles = {
  styleName?: 'outline' | 'primary' | 'secondary' | 'default' | 'inverted' | 'muted' | 'title' | null | undefined;
};

export type ISizes = {
  '2xl': String | string,
  xl: String | string,
  lg: String | string,
  md: String | string,
  sm: String | string,
  none: String | string
};

export type IStates = {
  true: String | string,
  false: String | string,
  null: String | string
};

export type IStyles = {
  outline: String | string,
  primary: String | string,
  secondary: String | string,
  default: String | string,
  inverted: String | string,
  muted: String | string,
  basic?: String | string | undefined,
  null: String | string
};

export const sizes = {
  '2xl': 'px-4 py-2',
  xl: 'px-[14px] py-[7px]',
  lg: 'px-3 py-1.5',
  md: 'px-[10px] py-[5px]',
  sm: 'px-2 py-1',
  none: 'px-1 py-0.5'
} as ISizes;

export const states = {
  true: 'border-green-500',
  false: 'border-red-500',
  null: 'border-slate-200'
} as IStates;

export const stylesText = {
  outline: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500',
  primary: 'text-primary duration-500 ease-in-out placeholder:text-slate-500',
  secondary: 'text-secondary duration-500 ease-in-out placeholder:text-slate-500',
  default: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500',
  inverted: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500',
  muted: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500',
  basic: 'text-black duration-500 ease-in-out placeholder:text-black',
  null: ''
} as IStyles;

export const stylesLink = {
  outline: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500',
  primary: 'text-primary duration-500 ease-in-out placeholder:text-slate-500',
  secondary: 'text-secondary duration-500 ease-in-out placeholder:text-slate-500',
  default: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500',
  inverted: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500',
  muted: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500',
  basic: 'text-black duration-500 ease-in-out placeholder:text-black',
  null: ''
} as IStyles;

export const stylesInput = {
  outline: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500 focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0 disabled:bg-slate-100',
  primary: 'text-primary duration-500 ease-in-out placeholder:text-slate-500 focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0 disabled:bg-slate-100',
  secondary: 'text-secondary duration-500 ease-in-out placeholder:text-slate-500 focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0 disabled:bg-slate-100',
  default: 'text-slate-500 duration-500 ease-in-out placeSholder:text-slate-500 focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0 disabled:bg-slate-100',
  inverted: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500 focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0 disabled:bg-slate-100',
  muted: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500 focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0 disabled:bg-slate-100',
  null: ''
} as IStyles;

export const stylesButton = {
  outline: 'bg-white text-black duration-500 ease-in-out border-slate-200 hover:bg-slate-100 font-medium focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0',
  primary: 'bg-primary text-white duration-500 ease-in-out border-transparent hover:bg-slate-600 font-medium focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0',
  secondary: 'bg-secondary text-white duration-500 ease-in-out border-transparent hover:bg-slate-600 font-medium focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0',
  default: 'bg-black text-white duration-500 ease-in-out border-transparent hover:bg-slate-600 font-medium focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0',
  inverted: 'bg-white text-black duration-500 ease-in-out border-transparent hover:bg-slate-400 font-medium focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0',
  muted: 'bg-slate-100 text-black duration-500 ease-in-out border-transparent hover:bg-slate-200 font-medium focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0',
  null: ''
} as IStyles;

export const stylesTable = {
  outline: 'text-slate-500 border-slate-200 duration-500 ease-in-out placeholder:text-slate-500',
  primary: 'text-primary border-slate-200 duration-500 ease-in-out placeholder:text-slate-500',
  secondary: 'text-secondary border-slate-200 duration-500 ease-in-out placeholder:text-slate-500',
  default: 'text-slate-500 border-slate-200 duration-500 ease-in-out placeholder:text-slate-500',
  inverted: 'text-slate-500 border-slate-200 duration-500 ease-in-out placeholder:text-slate-500',
  muted: 'text-slate-500 border-slate-200 duration-500 ease-in-out placeholder:text-slate-500',
  null: ''
} as IStyles;

export const stylesInputSelect = {
  outline: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500 focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0 disabled:bg-slate-100',
  primary: 'text-primary duration-500 ease-in-out placeholder:text-slate-500 focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0 disabled:bg-slate-100',
  secondary: 'text-secondary duration-500 ease-in-out placeholder:text-slate-500 focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0 disabled:bg-slate-100',
  default: 'text-slate-500 duration-500 ease-in-out placeSholder:text-slate-500 focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0 disabled:bg-slate-100',
  inverted: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500 focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0 disabled:bg-slate-100',
  muted: 'text-slate-500 duration-500 ease-in-out placeholder:text-slate-500 focus:ring-2 focus:xl:ring-4 focus:outline-none ring-slate-200 cursor-pointer disabled:cursor-not-allowed disabled:ring-0 disabled:bg-slate-100',
  null: ''
} as IStyles;
